import API from 'utils/api';
import formatValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import { toMoment } from 'utils/normalizers';
import { getContribuyente } from 'api/empresas/contribuyentes';

export const baseURI = 'empresas/contribuyentes-peritos/';

const formatPerito = (p) => ({
  ...p,
  fecha_vigencia: toMoment(p.fecha_vigencia),
  vigente: !!toMoment(p.fecha_vigencia)?.isSameOrAfter(toMoment(new Date())),
});

/**
 * GET PeritsDePredios
 * @param {Object} [params]
 * @returns {Promise<object[]>}
 */
export const getPeritosDePredios = async (params = {}) => {
  try {
    const response = await API.get(baseURI, { params });
    if (response.data.results) {
      response.data.results = response.data.results.map(formatPerito);
      return response.data;
    }
    return response.data.map(formatPerito);
  } catch (err) {
    onError(err);
    return params.page ? { results: [] } : [];
  }
};

/**
 * GET PeritoDePredio
 * @param {Object} [params]
 * @returns {Promise<object[]>}
 */
export const getCatalogoPeritosDePredio = async (_params = {}) => {
  const params = { ..._params, es_perito: true, page_size: 500 };
  try {
    const response = await API.get('/empresas/contribuyentes-ligero/', { params });
    if (response.data.results) {
      response.data.results = response.data.results.map(formatPerito);
      return response.data;
    }
    return response.data.map(formatPerito);
  } catch (err) {
    onError(err);
    return params.page ? { results: [] } : [];
  }
};

/**
 * GET PeritoDePredio
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getPeritoDePredio = async (id) => getContribuyente(id);

/**
 * POST PeritoDePredio
 * @param {object} values
 * @returns {Promise<object|null>}
 */
export const postPeritoDePredio = async (_values) => {
  const values = { ..._values, es_perito: true };
  try {
    const response = await API.post(baseURI, formatValues(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * PATCH PeritoDePredio
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|null>}
 */
export const patchPeritoDePredio = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, formatValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatPerito(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE PeritoDePredio
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePeritoDePredio = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
